import { tv, VariantProps } from 'tailwind-variants';

export const bannerTheme = tv({
  slots: {
    base: [
      'w-full',
      'border',
      'border-transparent',
      'rounded-2xl',
      'p-4',
      'flex',
      'items-center',
      'gap-2',
      'relative',
    ],
    iconWrapper: ['size-6', 'p-1', 'rounded-lg'],
    icon: ['size-4', 'shrink-0'],
    content: ['flex', 'justify-center', 'flex-grow', 'items-center', 'gap-3'],
    title: ['text-sm', 'font-medium'],
    description: ['text-sm'],
    actionsWrapper: ['flex', 'gap-3', 'items-center'],
    closeButton: [],
  },
  variants: {
    variant: {
      primary: {
        base: ['bg-primary-container'],
        iconWrapper: ['bg-primary-new'],
        icon: ['text-white'],
        title: ['text-primary-new'],
        description: ['text-primary-new'],
      },
      tertiary: {
        base: [
          'bg-surface-lowest',
          'border-outline-dark',
          'text-on-info-container',
        ],
        iconWrapper: ['bg-paragraph'],
        icon: ['text-white'],
        title: ['text-paragraph'],
        description: ['text-paragraph'],
      },
      'new-leads': {
        base: ['bg-secondary-container', 'text-on-secondary-container'],
        iconWrapper: ['bg-secondary-new'],
        icon: ['text-white'],
        title: ['text-on-secondary-container'],
        description: ['text-on-secondary-container'],
      },
    },
    kind: {
      solid: {},
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
});

export type BannerTheme = VariantProps<typeof bannerTheme>;
